import { USER_DEFINED_TREE_NAME } from '@grafana/alerting';

/**
 * Name of the custom annotation label used in k8s APIs for us to discern if a given entity was provisioned
 * @deprecated Use {@link K8sAnnotations.Provenance} instead
 * */
export const PROVENANCE_ANNOTATION = 'grafana.com/provenance';

export enum K8sAnnotations {
  Provenance = 'grafana.com/provenance',

  /** Annotation key that indicates how many notification policy routes are using this entity */
  InUseRoutes = 'grafana.com/inUse/routes',
  /** Annotation key that indicates how many alert rules are using this entity */
  InUseRules = 'grafana.com/inUse/rules',

  /** Annotation key that indicates that the calling user is able to write (edit) this entity */
  AccessWrite = 'grafana.com/access/canWrite',
  /** Annotation key that indicates that the calling user is able to admin the permissions of this entity */
  AccessAdmin = 'grafana.com/access/canAdmin',
  /** Annotation key that indicates that the calling user is able to delete this entity */
  AccessDelete = 'grafana.com/access/canDelete',
  /** Annotation key that indicates that the calling user is able to modify protected fields of this entity */
  AccessModifyProtected = 'grafana.com/access/canModifyProtected',
  /** Annotation key that indicates that the calling user is able to test this entity */
  AccessTest = 'grafana.com/access/canTest',

  /** Annotation key that indicates whether this entity can be used in routes and rules */
  CanUse = 'grafana.com/canUse',
}

/**
 * Name the K8S API uses for the root route in notification policies and the name the frontend SENDS.
 * Single-sourced from @grafana/alerting so the emitted value can never diverge. Read-side recognition of
 * the `default` alias is handled by isDefaultRoutingTreeName, not by this constant.
 */
export const ROOT_ROUTE_NAME = USER_DEFINED_TREE_NAME;

/** Resource type identifier for notification policy routes, used with the permissions API */
export const ROUTES_RESOURCE_TYPE = 'routingtrees';
